import View from 'ln/view/View';
import Node from 'ln/node/Node';

class FoldableElement extends View {

	constructor(  data:any = {} ) {
		
		super( data );
		this.defaultTemplate = 'lb.foldable-element';
	}

    init() {
        this.node.js( 'button' ).click.add( ( node:Node, event: Event ) => {
            this.node.js( 'text').toggleClass( '-hidden' );
        });
    }

}


export default FoldableElement;